<template>
    <div class="f fj-c fa-c fv br-m dw-10 dh-10 sp-l el-empty"
        :class="[
            'el--s-' + uiSize,
            'el--t-' + uiStyle,
        ]">
        <span v-if="uiIconHtml" v-html="uiIconHtml"></span>
        <i v-if="uiIcon"
            class="ta-c"
            :class="['lnr-' + uiIcon, iconSpaceClass]"
            aria-hidden="true"></i>
        <h6 v-if="uiTitle"
            class="ta-c u-us-n"
            :class="[titleClass]"
            v-html="$options.filters.athT(uiTitle, uiTitleParams)">
        </h6>
        <p v-if="uiDescription"
            class="ta-c"
            :class="[descriptionClass]"
            v-html="$options.filters.athT(uiDescription, uiDescriptionParams)">
        </p>
        <slot name="cta"></slot>
    </div>
</template>

<script>
export default {
    name: 'mead-empty',
    props: {
        /**
         * Visual style of the empty state, controlling background/spacing and
         * title/description/icon sizing. One of 'basic', 'aside', 'panel',
         * 'panelinside' or 'page'.
         */
        uiStyle             : {type: String, default: () => 'panelinside'},
        /**
         * Overall size modifier applied to the container via `el--s-{uiSize}`.
         */
        uiSize              : {type: String, default: () => 'm'},
        /**
         * Name of an icon (rendered via `lnr-{uiIcon}`) shown above the title.
         */
        uiIcon              : {type: [Boolean, String], default: () => false},
        /**
         * Raw HTML rendered above the title instead of/alongside `uiIcon`, via `v-html`.
         */
        uiIconHtml          : {type: [Boolean, String], default: () => false},
        /**
         * Translation key for the empty state's title text, run through the
         * `athT` filter and rendered as HTML.
         */
        uiTitle             : {type: [Boolean, String], default: () => false},
        /**
         * Interpolation params passed to the `athT` filter alongside `uiTitle`.
         */
        uiTitleParams       : {type: Object, default: () => ({})},
        /**
         * Translation key for the empty state's description text, run through
         * the `athT` filter and rendered as HTML.
         */
        uiDescription       : {type: [Boolean, String], default: () => false},
        /**
         * Interpolation params passed to the `athT` filter alongside `uiDescription`.
         */
        uiDescriptionParams : {type: Object, default: () => ({})},
    },
    computed: {
        titleClass: function () {
            if (this.uiStyle === 'aside') return 'te-fat-small';
            if (this.uiStyle === 'page') return 'te-fat-light';
            return 'te-title-entity';
        },
        descriptionClass: function () {
            if (this.uiStyle === 'page') return 'sm-t-s te-note';
            return 'sm-t-xs te-note';
        },
        iconSpaceClass: function () {
            if (this.uiStyle === 'aside') return 'sm-b-l';
            if (this.uiStyle === 'page') return 'sm-b-s';
            return 'sm-b-xs';
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.el-empty {
    &.el--t-basic {
        background: transparent;

        i {
            font-size: $fs-xxl;
            line-height: $fs-xxl;
        }
    }

    &.el--t-aside {
        background: transparent;
        color: var(--c-txt-bold);

        i {
            font-size: $fs-hero;
            line-height: $fs-hero;
        }
    }

    &.el--t-panel {
        i {
            font-size: $fs-xxl;
            line-height: $fs-xxl;
        }
    }

    &.el--t-panelinside {
        background: var(--c-panel-dark-bg);
        color: var(--c-txt-bold);
        padding: $s-xxl;

        i {
            font-size: $fs-xxl;
            line-height: $fs-xxl;
        }
    }

    &.el--t-page {
        background: transparent;
        color: var(--c-txt-bold);
        padding: $s-xxl;

        i {
            font-size: $fs-massive;
            line-height: $fs-massive;
        }
    }
}

i {
    color: var(--c-txt-light);
}
</style>
